module.exports = __webpack_public_path__ + "32342dd6988c6742a27903a8a7f7f303.png";